module.exports = __webpack_public_path__ + "static/img/chart_title2.27215e31.png";